import { useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const IndicatorsContainer = ({
  children,
  isMulti,
  hasValue,
  selectProps: {
    customTheme,
    customStyles
  }
}) => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(Div, _extends({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: isMulti && hasValue ? '60px' : '',
    px: `${theme.spacing.xs}px`,
    height: "auto",
    color: customTheme.palette.grey[100]
  }, customStyles.indicators), children);
};

export default IndicatorsContainer;
